package org.example.zone360.pages.widgets.methodologyWidget


import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.components.BSTooltip
import com.stevdza.san.kotlinbs.models.TooltipDirection
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.widgetTitleFontSize
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.MethodologyConsistency
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.models.WidgetTrend
import org.example.zone360.pages.dashboard.chart.MiniBars
import org.example.zone360.pages.widgets.helper.WidgetTooltipIcon
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput
import org.w3c.dom.HTMLInputElement


@Composable
fun MethodologyConsistencyWidget(
    data: MethodologyConsistency,
    modifier: Modifier = Modifier,
    widgetNo: Int,
    widgetName: String,
    widgetGaugeID: String,
    widgetColor: Color,
    isTalk: Boolean,
    isCoachPage: Boolean = false,
    sessionBorder: Boolean = false,
    forceFullWidth: Boolean = false,
    trendData: List<WidgetTrend> = emptyList(),
    showSelection: Boolean = false,
    isSelected: Boolean = false,
    onSelectionChange: ((Boolean) -> Unit)? = null,
    tooltipText: String = "",
    tooltipTitle: String = "",
    tooltipInline: Boolean = false,
) {
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var isModalOpen by remember { mutableStateOf(false) }
    var widgetDetailResponse by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    val isEmpty = data.consistentPrinciples.isEmpty()
    var isLoading by remember { mutableStateOf(false) }

    Box(
        modifier = modifier
            .then(
                when {
                    forceFullWidth -> Modifier.fillMaxHeight()   // ✅ session detail
                    sessionBorder -> Modifier.fillMaxWidth()    // ✅ session border card
                    else -> Modifier.minWidth(                  // ✅ normal dashboard
                        when {
                            breakpoint < Breakpoint.MD -> 320.px
                            showSelection -> 280.px
                            window.screen.width in 1200..1500 -> 318.px
                            else -> 350.px
                        }
                    )
                }
            )
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(if (showSelection) 12.px else 16.px)
            .padding(if (showSelection) 12.px else if (sessionBorder) 15.px else 20.px)
            .border(
                if (showSelection) 2.px else if (sessionBorder) 1.px else 0.px,
                LineStyle.Solid,
                Color.rgb(220, 220, 220)
            )
            .then(
                when {
                    breakpoint < Breakpoint.MD -> Modifier
                    sessionBorder -> Modifier.height(285.px)
                    !showSelection -> Modifier.height(380.px)
                    else -> Modifier
                }
            )
            .styleModifier {
                property("position", "relative")
            }
    )
    {
        if (showSelection) {
            Box(
                modifier = Modifier
                    .styleModifier {
                        property("position", "absolute")
                        property("top", "9px")
                        property("right", "9px")
                        property("cursor", "pointer")
                    }
                    .zIndex(9999)
            ) {

                CheckboxInput(
                    checked = isSelected
                ) {
                    onChange { event ->
                        onSelectionChange?.invoke(
                            (event.target as HTMLInputElement).checked
                        )
                    }

                    style {
                        property("transform", "scale(1.4)")
                        property("cursor", "pointer")
                    }
                }
            }
        }
        Column(modifier = Modifier.fillMaxWidth().then(
            if (breakpoint < Breakpoint.MD) Modifier
            else Modifier.height(if (showSelection) 350.px else 340.px)
        )) {
            // Header row with badge + title
            Row(
                verticalAlignment = if (sessionBorder) Alignment.Top else Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth().margin(bottom = 8.px)
                    .then(
                        if (showSelection) Modifier.padding(right = 26.px) else Modifier
                    )
            ) {
                Box(
                    modifier = Modifier
                        .width(if (sessionBorder) 24.px else 28.px)
                        .height(if (sessionBorder) 24.px else 28.px)
                        .backgroundColor(widgetColor)
                        .borderRadius(6.px)
                        .margin(right = 10.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = widgetNo.toString(),
                        fontSize = 14.px,
                        fontWeight = 700,
                        color = sitePalette.bodyBackground.rgb
                    )
                }
                FieldTitleTextNormalSimple(
                    text = widgetName,
                    fontSize = widgetTitleFontSize(showSelection, sessionBorder, breakpoint),
                    fontWeight = 700
                )
                if (tooltipInline && showSelection) {
                    if (tooltipText.isNotEmpty()) {
                        WidgetTooltipIcon(
                            tooltipTitle = tooltipTitle,
                            tooltipText = tooltipText,
                            modifier = Modifier.margin(left = 6.px, bottom = 13.px)
                        )
                    }
                } else {
                    if (!showSelection) {
                        Box(modifier = Modifier.weight(1f))
                    }
                    if (tooltipText.isNotEmpty()) {
                        WidgetTooltipIcon(
                            tooltipTitle = tooltipTitle,
                            tooltipText = tooltipText,
                            modifier = Modifier.margin(left = 8.px)
                        )
                    }
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(top = if (sessionBorder) 0.px else 8.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (sessionBorder) Arrangement.SpaceEvenly else Arrangement.SpaceAround
            ) {

                // Premium Shield Container
                Box(
                    modifier = Modifier
                        .size(100.px)
                        .borderRadius(50.percent)
                        .styleModifier {
                            property("position", "relative")
                        },
                    contentAlignment = Alignment.Center
                ) {

                    // Main Circle
                    Box(
                        modifier = Modifier
                            .size(
                                when {
                                    sessionBorder -> 90.px
                                    showSelection -> 95.px
                                    else -> 90.px
                                }
                            )
                            .borderRadius(50.percent)
                            .backgroundColor(Colors.White)
                            .styleModifier {
                                property(
                                    "box-shadow",
                                    "0 8px 25px rgba(59,130,246,0.15)"
                                )
                                property(
                                    "border",
                                    "2px solid rgba(59,130,246,0.15)"
                                )
                            }
                    )

                    // Orbit Ring
                    Box(
                        modifier = Modifier
                            .size(
                                when {
                                    sessionBorder -> 75.px
                                    showSelection -> 75.px
                                    else -> 115.px
                                }
                            )
                            .borderRadius(50.percent)
                            .styleModifier {
                                property(
                                    "border",
                                    "2px solid rgba(59,130,246,0.12)"
                                )
                            }
                    )

                    // Shield
                    Image(
                        src = Res.Images.shield,
                        modifier = Modifier
                            .size(if (sessionBorder) 50.px else 72.px)
                            .borderRadius(50.percent)
                    )
                }
                Column(modifier = Modifier) {

                    // Score
                    FieldTitleTextNormalSimple(
                        text = "${data.score}%",
                        fontSize = if (showSelection || sessionBorder) 22.px else 26.px,
                        fontWeight = 600,
                        color = widgetColor
                    )

                    FieldTitleTextNormalSimple(
                        text = "Consistent Principles",
                        fontSize = if (showSelection || sessionBorder) 12.px else 15.px,
                        fontWeight = 600,
                        color = Color.rgb(107, 114, 128)
                    )
                }
            }
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(if (showSelection) 90.px else if (sessionBorder) 75.px else 112.px)
                    .margin(top = if (showSelection) 15.px else 0.px),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {

                if (isEmpty) {

                    Box(
                        modifier = Modifier.fillMaxWidth(),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "No Data Available",
                            fontSize = 14.px,
                            fontWeight = 500,
                            color = Palette.CoachTalkTableHeaderText.rgbLight
                        )
                    }

                } else {

                    Column(
                        modifier = Modifier,
                        horizontalAlignment = Alignment.Start
                    ) {

                        data.consistentPrinciples.take(3).forEach { principle ->

                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .margin(bottom = if (showSelection) 5.px else 3.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {

                                Box(
                                    modifier = Modifier
                                        .size(18.px)
                                        .backgroundColor(Color.rgb(34, 197, 94))
                                        .borderRadius(50.percent),
                                    contentAlignment = Alignment.Center
                                ) {
                                    SpanText(
                                        text = "✓",
                                        modifier = Modifier
                                            .fontSize(11.px)
                                            .color(Colors.White)
                                    )
                                }

                                Box(
                                    modifier = Modifier.margin(left = 12.px)
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = principle,
                                        fontSize = if (sessionBorder) 13.px else 14.px,
                                        fontWeight = 500
                                    )
                                }
                            }
                        }
                    }
                }
            }
            val avgLabel = when {
                sessionBorder -> "Avg"
                isCoachPage -> "Coach Avg"
                else -> "Club Avg"
            }
            CustomSpacer(height = if (sessionBorder) 3.px else 0.px)
            Box(
                modifier = Modifier
                    .backgroundColor(Palette.WidgetAverageBackground.rgbLight)
                    .borderRadius(99.px)
                    .alignSelf(AlignSelf.Center)
                    .padding(leftRight = 10.px, topBottom = 4.px),
                contentAlignment = Alignment.Center
            ) {
                FieldTitleTextNormalSimple(
                    text = "$avgLabel: ${data.score}%",
                    fontSize = 11.px,
                    fontWeight = 500,
                    color = Palette.WidgetAverageText.rgbLight
                )
            }

            Spacer()
            // Footer - View Details
            if (!sessionBorder) {
                if (isCoachPage) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = if (showSelection) 4.px else 14.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .cursor(Cursor.Pointer)
                                .margin(top = 4.px)
                        ) {
                            MiniBars(
                                color = widgetColor,
                                trends = trendData
                            )
                        }
                    }

                } else {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(42.px)
                            .margin(top = 16.px)
                            .backgroundColor(Palette.ViewDetailBackground.rgbLight)
                            .borderRadius(10.px)
                            .border(
                                1.px,
                                LineStyle.Solid,
                                color = Palette.ViewDetailBorder.rgbLight
                            )
                            .cursor(Cursor.Pointer)
                            .onClick {
                                isModalOpen = true
                            }
                    ) {

                        // Centered text
                        Box(
                            modifier = Modifier.fillMaxSize(),
                            contentAlignment = Alignment.Center
                        ) {
                            if (isLoading) {
                                ProgressIndicator(size = 20.px)
                            } else {
                                FieldTitleTextNormalSimple(
                                    text = "View Details",
                                    fontSize = 14.px,
                                    fontWeight = 600,
                                    color = Palette.ViewDetailText.rgbLight
                                )
                            }
                        }
                        // Right aligned arrow
                        Box(
                            modifier = Modifier
                                .fillMaxHeight()
                                .fillMaxWidth()
                                .padding(right = 14.px),
                            contentAlignment = Alignment.CenterEnd
                        ) {
                            FaAngleRight(
                                modifier = Modifier
                                    .width(14.px)
                                    .height(14.px)
                                    .color(Palette.ViewDetailAngle.rgbLight)
                            )
                        }
                    }
                }
            }
        }
    }

    if (isModalOpen) {
        MethodologyConsistencyDetailsModal(
            widgetNo = widgetNo,
            widgetName = widgetName,
            widgetColor = widgetColor,
            widgetKey = "methodology_consistency",
            consistentPrinciples = data.consistentPrinciples,
            data = null,   // WidgetDetailResponse from API
            onClose = { isModalOpen = false }
        )
    }
}
